import {
  CkeditorPayload,
  DynamicFieldAttributeInsertExecutePayload,
  DynamicFieldCreateOrUpdateExecutePayload,
  DynamicFieldExecutePayload,
} from './ckeditor-payload.model';
import { FormFieldBase } from './form-field-base.model';

export class DynamicField extends FormFieldBase {
  constructor(options: Record<any, any> = {}) {
    super(options);
    this.fieldType = 'dynamicField';
  }
  override getAttributePayloadForCk(): { attributeKey: string; value: string }[] {
    return [
      {
        attributeKey: this.getCkAlias('dynamicFieldName'),
        value: (this.label as string) || '',
      },
      {
        attributeKey: this.getCkAlias('type'),
        value: `${this.controlType}:${this.type}`,
      },
    ];
  }

  override getCommandPayloadToUpdateAttribute(data: {
    key: string;
    attributes: {
      attributeKey: string;
      value: string;
    }[];
  }): DynamicFieldAttributeInsertExecutePayload {
    return new DynamicFieldAttributeInsertExecutePayload({
      payload: data,
    });
  }

  override getCommandPayloadToCreate(value: string): CkeditorPayload {
    return new DynamicFieldExecutePayload({
      payload: {
        key: this.key,
        label: this.label,
        value: value,
        type: `${this.controlType}:${this.type}`,
        metadata: (this.options || []).join('||'),
      },
    });
  }

  getCommandPayloadToCreateOrUpdate(data: {
    key: string;
    attributes: {
      attributeKey: string;
      value: string;
    }[];
  }): DynamicFieldCreateOrUpdateExecutePayload {
    return new DynamicFieldCreateOrUpdateExecutePayload({
      payload: data,
    });
  }

  override getPlaceHolder(): string {
    return `<span class="label-fake-mask">${this.label}</span>`;
  }
}
